import { getApps } from 'firebase/app';

const DEFAULT_APP_NAME = '[DEFAULT]';

export class MissingStagingConfigError extends Error {
  constructor(primary) {
    super(`Cliente "${primary?.Proyecto || '(sin nombre)'}" no tiene Firebase.stagingURL configurado.`);
    this.name = 'MissingStagingConfigError';
    this.primary = primary;
  }
}

// Resuelve qué config de Firebase usar para el secondary según el entorno.
// - prod (default): usa primary.Firebase tal cual.
// - staging: requiere primary.Firebase.stagingURL y reemplaza databaseURL.
//   Si stagingURL no existe, lanza MissingStagingConfigError.
export function resolveSecondaryFirebaseConfig(primary) {
  const baseConfig = primary?.Firebase;
  if (!baseConfig) {
    throw new Error('Client no tiene Firebase config');
  }
  if (process.env.REACT_APP_ENV !== 'staging') {
    return baseConfig;
  }
  if (!baseConfig.stagingURL) {
    throw new MissingStagingConfigError(primary);
  }
  return { ...baseConfig, databaseURL: baseConfig.stagingURL };
}

export function getActiveSecondaryApp() {
  const apps = getApps();
  const preferredAppName = window.localStorage.getItem('SECONDARY_DATA_NAME');

  if (preferredAppName) {
    const appByName = apps.find((app) => app.name === preferredAppName);
    if (appByName) {
      return appByName;
    }
  }

  try {
    const primaryRaw = window.localStorage.getItem('PRIMARY_DATA');
    if (primaryRaw) {
      const primaryData = JSON.parse(primaryRaw);
      let expectedDatabaseUrl;
      try {
        expectedDatabaseUrl = resolveSecondaryFirebaseConfig(primaryData).databaseURL;
      } catch (err) {
        expectedDatabaseUrl = primaryData?.Firebase?.databaseURL;
      }

      if (expectedDatabaseUrl) {
        const appByDatabase = apps.find(
          (app) => app.name !== DEFAULT_APP_NAME && app.options?.databaseURL === expectedDatabaseUrl
        );
        if (appByDatabase) {
          return appByDatabase;
        }
      }
    }
  } catch (err) {
    console.warn('No se pudo resolver app secundaria por PRIMARY_DATA', err);
  }

  return apps.find((app) => app.name !== DEFAULT_APP_NAME) || null;
}

export function getNonDefaultApps() {
  return getApps().filter((app) => app.name !== DEFAULT_APP_NAME);
}
